module.exports = __webpack_public_path__ + "img/passionateaboutdevelopment_completed.d14a763f.svg";